import React from 'react';
import { useNavigate } from 'react-router-dom';
import WebApp from '@twa-dev/sdk';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { checkTelegramLinkedStatus, verifyTelegramCode } from '../composables/fetchAPI';

type TgUser = {
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  language_code?: string;
  is_premium?: boolean;
};

const TelegramConnectPage = () => {
  const navigate = useNavigate();
  const [startParam, setStartParam] = useState<string | null>(null);
  const [user, setUser] = useState<TgUser | null>(null);
  const [verified, setVerified] = useState<boolean | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [isLinked, setIsLinked] = useState<boolean | null>(null); // State for linked status
  const [inputCode, setInputCode] = useState<string>(''); // State for text input




  useEffect(() => {
    // บอก Telegram ว่าพร้อมแล้ว
    WebApp.ready();
    WebApp.expand(); // ให้เต็มพื้นที่สวยๆ

    // ดึงค่าจาก initDataUnsafe
    const u = WebApp.initDataUnsafe?.user || null;
    const sp = WebApp.initDataUnsafe?.start_param || null;

    setUser(u ?? null);
    setStartParam(sp ?? null);
    setInputCode(sp ?? '');
    // ส่ง initData ทั้งก้อนไป backend เพื่อตรวจสอบความถูกต้อง
    const doVerify = async () => {
      try {
        const res = await fetch('/api/telegram/verify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            initData: WebApp.initData, // string raw
          }),
        });
        const json = await res.json();
        if (!res.ok || !json.ok) throw new Error(json.message || 'verify_failed');
        setVerified(true);
        // เก็บ session/token ของระบบเราได้ที่นี่ (json.token)
      } catch (e: any) {
        setVerified(false);
        setErr(e?.message ?? 'verify_error');
      }
    };

    doVerify();
  }, []);

  useEffect(() => {
    if (user?.id) {
      const checkLinkedStatus = async () => {
        try {
          const response = await checkTelegramLinkedStatus(user.id.toString());
          setIsLinked(response.linked); // Update linked status
          // toast.success(`Your Telegram account is ${response.isLinked ? 'linked' : 'not linked'}.`);
          // Show toast based on the linked status
          // if (response.isLinked) {
          //   toast.success('Your Telegram account is linked!');
          // } else {
          //   toast.error('Your Telegram account is not linked.');
          // }
        } catch (error) {
          console.error('Failed to check linked status:', error);
          setIsLinked(false);
          toast.error(`Failed to check Telegram linked status. ${error}`);
          // toast.error(`Failed to check Telegram linked status. ${localStorage.getItem('authToken')}`);

        }
      };

      checkLinkedStatus();
    }
  }, [user]);

  useEffect(() => {
    if (isLinked) {
      toast.error('คุณได้ทำการเชื่อม Telegram แล้ว ไม่ต้องเชื่อมต่ออีกรอบแล้วจ้า~');
      setTimeout(() => {
        WebApp.close(); // ปิด Web App
      }, 5000); // รอ 2 วินาทีก่อนเปลี่ยนหน้า
    }
  }, [isLinked, navigate]);


const handleVerifyCode = async () => {
  try {
    if (!inputCode) {
      toast.error('กรุณากรอกโค้ด');
      return;
    }

    const payload = {
      telegramFirstname: user?.first_name  || '',
      // telegramLastname: user?.last_name || '',
      telegramId: user?.id?.toString() || '',
      code: inputCode , // ใช้ inputCode เป็น code
    };
    // toast.success(`กำลังตรวจสอบโค้ด...${JSON.stringify(payload)}`);
    // console.log('Payload:', payload); // Debugging
    const response = await verifyTelegramCode(payload);

    if (response.success) {
      toast.success('เชื่อมต่อ Telegram สำเร็จ!');
      setTimeout(() => {
        WebApp.close(); // ปิด Web App
      }, 2000);
    } else {
      throw new Error(response.message || 'การเชื่อมต่อล้มเหลว');
    }
  } catch (error: any) {
    toast.error(`เกิดข้อผิดพลาด: ${error.message}`);
  }
};

  return (
    <div className="min-h-screen flex flex-col items-center justify-center" style={{ backgroundColor: '#1a1a1a', color: '#fff' }}>
      <div className="flex flex-col items-center p-6 rounded-lg shadow-lg" style={{ backgroundColor: '#2a2a2a', width: '300px' }}>
        <img src="https://cdn-icons-png.flaticon.com/512/2111/2111646.png" alt="Telegram" className="w-16 h-16 mb-4" />
        <h1 className="text-xl font-bold mb-2 text-center" style={{ color: '#ffd700' }}>Welcome to WeThaiInvest</h1>
        <p className="text-sm mb-4 text-center">กรุณากรอกโค้ดของคุณ</p>
        <input
          type="text"
          value={inputCode}
          onChange={(e) => setInputCode(e.target.value)}
          className="w-full px-4 py-2 rounded text-center text-lg font-mono"
          style={{ backgroundColor: '#fff', color: '#000' }}
        />
        <button
          onClick={handleVerifyCode}
          disabled={!inputCode}
          className={`w-full mt-4 px-4 py-2 rounded flex items-center justify-center gap-2 ${inputCode ? 'bg-blue-500 text-white' : 'bg-gray-400 text-gray-700'
            }`}
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/2111/2111646.png"
            alt="Telegram Icon"
            className="w-4 h-4"
          />
          เชื่อมต่อ Telegram
        </button>
        {user && (<div className="mt-4 text-sm text-center">
          <p>Telegram User:</p>
          <p><strong>{user.first_name} {user.last_name}</strong> (@{user.id})</p>
        </div>
        )}
      </div>
    </div>
  );
};

export default TelegramConnectPage;